import { pendingTask, begin, end } from "react-redux-spinner";
import { put } from "redux-saga/effects";

import UserFeedback from "../user.feedback";
import {
  IChangePasswordRequest,
  changePasswordResponse
} from "../user.actions";
import UserService from "../user.service";

export function* changePasswordSaga(action: IChangePasswordRequest) {
  if (action.payload instanceof Error) {
    return;
  }

  yield put({ type: "SPINNER", [pendingTask]: begin });
  try {
    const { newPassword, oldPassword } = action.payload;
    const service = new UserService();
    const response = yield service.changePassword(oldPassword, newPassword);
    yield put(changePasswordResponse(response, UserFeedback.PASSWORD_CHANGED));
  } catch (error) {
    yield put(
      changePasswordResponse(error, UserFeedback.PASSWORD_CHANGE_FAILED)
    );
  }
  yield put({ type: "SPINNER", [pendingTask]: end });
}
